import { Plus } from "../Icons";
import styles from "./CreateLink.module.css";

const CreateLink = ({ createFn, text }: { createFn: () => void; text: string }) => (
  <button className={styles.link} type='button' onClick={createFn}>
    <Plus width='64px' height='64px' /> {text}
  </button>
);

export default CreateLink;
